import { connect } from 'react-redux';
import { getStatusById } from 'selectors/presence';
import { getUserByIdSelector } from 'selectors/search';
import { getCurrentUserIdSelector } from 'selectors/user';
import  { selectors } from '@amplement/backend-connector';

import UserItem from './index';

const mapStateToPropsContact = (state, { _user, noStatus }) => {
    const user = getUserByIdSelector(state, _user) || {};
    const status = noStatus ? null : getStatusById(state, _user);

    return {
        ...user,
        status,
    };
};

export const contact = connect(
    mapStateToPropsContact,
    null
)(UserItem);


const mapStateToPropsMember = (state, { _user, _feed, noStatus }) => {
    const _currentUser = getCurrentUserIdSelector(state);
    const user = getUserByIdSelector(state, _user) || {};
    const status = noStatus ? null : getStatusById(state, _user);
    const feed = selectors.feeds.feedByIdSelector(state, _feed);
    const memberStatus = selectors.members.getFeedMemberStatusSelector(state, _feed, _user);
    const isAdmin = feed?._administrators?.includes(user?.id);
    const isInitiator = user?.id === feed?._user;
    const isMe = _currentUser === _user;

    return {
        ...user,
        status,
        memberStatus,
        isAdmin: feed?._administrators === undefined ? isInitiator : isAdmin,
        isInitiator,
        isMe
    };
};

export const member = connect(
    mapStateToPropsMember,
    null
)(UserItem);
